import AbstractPageBaseController from '../../../../../modules/core/abstracts/controllers/page-controller';

export default class BillingInvoiceTemplatesAbstractEditorController extends AbstractPageBaseController {
    constructor($scope, $injector) {
        super($scope, $injector);

        this.navHelper = this.injector.get('NavHelper');
        this.stateParams = this.injector.get('$stateParams');
        this.state = this.injector.get('$state');
        this.alert = this.injector.get('Alert');
        this.translate = this.injector.get('$translate');
        this.api = this.injector.get('$http');

        this.model = {
            title: '',
            subject: '',
            template: '',
            enable_for_invoice: true,
            enable_for_bid: false,
            enable_for_cancellation: false,
            processing_costs_per_person: 0,
            processing_costs_general: 0,
            number_circle_id: null,
            text_1: '',
            text_2: '',
            text_3: '',
            tax_rate: 19.0,
            processing_costs_general_position_id: '',
            processing_costs_per_person_position_id: '',
            shipping_costs_position_id: ''
        };
        this.templateFieldConfig = {
            type: 'ace',
            aceOptions: {
                useWrapMode: false,
                highlightActiveLine: false,
                showGutter: false,
                theme: 'chrome',
                mode: 'twig',
                require: [
                    'ace/ext/language_tools'
                ],
                advanced: {
                    enableBasicAutocompletion: true,
                    enableSnippets: true,
                    enableLiveAutocompletion: true
                },
                onLoad: function (editor) {

                }
            }
        }
        this.loading = true;
        this.numberCircles = [];
        this.billingPositions = [];
        this.submitting = false;
    }

    $onInit() {
        this._loadNumberCircles();
        this._loadBillingPositions();
    }

    save(form) {
        if (!form.$valid) {
            return;
        }
        this.submitting = true;

        this.doSave();
    }

    doSave() {
        console.log('do save not implemented');
    }

    cancel() {
        if (this.stateParams.store) {
            this.stateParams.store.dispatch('getData');
        }
        this.state.go('app.billing.invoice_templates.index');
    }

    _loadNumberCircles() {
        this.api
            .post(
                'fp/billing/number_circles',
                {
                    fields: [
                        'title',
                        'id'
                    ]
                }
            )
            .then(({data}) => {
                this.numberCircles = [];
                _.each(data.data, (cat) => {
                    this.numberCircles.push(cat);
                })
            })
    }

    _loadBillingPositions() {
        this.api
            .post(
                'fp/billing/positions',
                {
                    fields: [
                        'title',
                        'id'
                    ]
                }
            )
            .then(({data}) => {
                this.billingPositions = [{
                    id: '',
                    title: '--'
                }];
                _.each(data.data, (cat) => {
                    this.billingPositions.push(cat);
                })
            })
    }

    prepareModelForApi() {
        return {
            ...this.model,
            processing_costs_general_position_id: this.model.processing_costs_general_position_id ? this.model.processing_costs_general_position_id : null,
            processing_costs_per_person_position_id: this.model.processing_costs_per_person_position_id ? this.model.processing_costs_per_person_position_id : null,
            shipping_costs_position_id: this.model.shipping_costs_position_id ? this.model.shipping_costs_position_id : null,
        };
    }
}



// WEBPACK FOOTER //
// ./src/app/pages/billing/invoice_templates/controllers/pages/abstract-editor-controller.js